// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Button, Icon, Menu } from "semantic-ui-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DashboardBarButton = props => {
  const {
    children,
    icon,
    label,
    labelPosition,
    disabled,
    loading,
    onClick,
    ...rest
  } = props;
  const trigger = React.useMemo(() => /*#__PURE__*/_jsxs(Menu.Item, {
    as: Button,
    icon: true,
    labelPosition: labelPosition,
    disabled: disabled || loading,
    loading: loading,
    onClick: onClick,
    ...rest,
    children: [/*#__PURE__*/_jsx(Icon, {
      name: icon
    }), label]
  }), [icon, disabled, loading, rest, children, onClick]);
  return trigger;
};
export default DashboardBarButton;